import { PaginationDetails } from "./api_request";

export interface ChangePasswordField {
  old_password: string;
  new_password: string;
}

export interface UserDataPropsType {
  created_at: string;
  email: string;
  first_name: string;
  gender: string;
  isVerified: boolean;
  lastLogin: string;
  last_name: string;
  name: string;
  middle_name: string;
  phone_number: string;
  role: string;
  updated_at: string;
  _id: string;
}

export const UserDataPropsTypeDummy = {
  created_at: "",
  email: "",
  first_name: "",
  gender: "",
  isVerified: false,
  lastLogin: "",
  last_name: "",
  name: "",
  middle_name: "",
  phone_number: "",
  role: "",
  updated_at: "",
  _id: "",
}

export interface UsersDataProps {
  created_at: string;
  email: string;
  first_name: string;
  gender: string;
  isVerified: boolean;
  lastLogin: string;
  last_name: string;
  rolePermissions: any[];
  middle_name: string;
  phone_number: string;
  role: string;
  updated_at: string;
  _id: string;
}

export const UsersDummyData = {
  created_at: "",
  email: "",
  first_name: "",
  gender: "",
  isVerified: false,
  lastLogin: "",
  last_name: "",
  rolePermissions: [],
  middle_name: "",
  phone_number: "",
  role: "",
  updated_at: "",
  _id: "",
};

export interface UsersComponentProps {
  usersList: UsersDataProps[];
  isLoading: boolean;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}

export interface UserRoleData {
  created_at: string;
  description: string;
  name: string;
  updated_at: string;
  permissions: any[];
  user_info: {
    email: string;
    name: string;
    _id: string;
  };
  _id: string;
}

export const UserRoleDummyData: UserRoleData = {
  created_at: "",
  description: "",
  name: "",
  updated_at: "",
  permissions: [],
  user_info: {
    email: "",
    name: "",
    _id: "",
  },
  _id: "",
};
